(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-ia-advisory-popup"]) return;
  try {
    
  if (!customElements.get('dm-ia-advisory')) {
    customElements.define('dm-ia-advisory', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const dialog = this.querySelector('.dmia-dialog');
        const form = this.querySelector('.dmia-form');
        const launcher = this.querySelector('.dmia-launcher');
        const country = this.querySelector('#DmIaCountry');
        const phone = this.querySelector('#DmIaPhone');
        const internationalPhone = this.querySelector('#DmIaInternationalPhone');
        const dialCode = this.querySelector('#DmIaDialCode');
        const time = this.querySelector('#DmIaTime');
        const custom = this.querySelector('#DmIaCustomTime');
        const fields = this.querySelector('.dmia-fields');
        const success = this.querySelector('.dmia-success');
        const error = this.querySelector('.dmia-error');
        const status = this.querySelector('.dmia-response').dataset.response;
        const seenKey = 'dm-ia-advisory-seen-v1';
        const pendingKey = 'dm-ia-advisory-pending-v1';
        const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
        const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
        const clearPending = () => { try { sessionStorage.removeItem(pendingKey); } catch {} };
        let previousFocus;
        let interacted = false;
        this.dialog = dialog;
        const syncPhone = () => {
          const selected = country.selectedOptions[0].dataset;
          const dial = selected.dial;
          dialCode.textContent = `+${dial}`;
          const raw = phone.value.trim();
          const digits = raw.replace(/[^0-9]/g, '');
          const hasPrefix = raw.startsWith('+');
          let message = '';
          let national = digits;
          const lengths = selected.lengths.split(',').map(Number);
          const numberPattern = new RegExp(`^(?:${selected.pattern})$`);
          if (hasPrefix) {
            if (digits.startsWith(dial)) national = digits.slice(dial.length);
            else message = phone.dataset.countryMismatch;
          }
          if (!hasPrefix && selected.prefix) {
            const prefixPattern = new RegExp(`^(?:${selected.prefix})`);
            const prefixMatch = prefixPattern.exec(national);
            if (prefixMatch) {
              const replacement = selected.transform && prefixMatch.slice(1).some(value => value) ? selected.transform : '';
              const candidate = national.replace(prefixPattern, replacement);
              if (lengths.includes(candidate.length) && numberPattern.test(candidate)) national = candidate;
            }
          }
          if (raw && !message && (!/^\+?[0-9\s().-]+$/.test(raw) || !lengths.includes(national.length) || !numberPattern.test(national) || national.length + dial.length > 15)) {
            message = phone.dataset.invalid;
          }
          phone.setCustomValidity(message);
          internationalPhone.value = raw && !message ? `+${dial}${national}` : '';
        };
        const syncTime = () => {
          const selected = time.value === 'Personalizado';
          custom.closest('.dmia-custom').hidden = !selected;
          custom.disabled = !selected;
          custom.required = selected;
        };
        const open = () => {
          if (dialog.open || !this.isConnected) return;
          previousFocus = document.activeElement;
          dialog.showModal();
          document.documentElement.classList.add('dmia-scroll-lock');
          launcher.hidden = true;
          write(seenKey, '1');
          const focusTarget = !success.hidden ? success : !error.hidden ? error : this.querySelector('#DmIaTitle');
          focusTarget.focus({ preventScroll: true });
        };
        const close = () => { if (dialog.open) dialog.close(); };
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', close, { signal }));
        launcher.addEventListener('click', open, { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }, { signal });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('dmia-scroll-lock');
          launcher.hidden = false;
          const target = previousFocus instanceof HTMLElement && previousFocus !== document.body && previousFocus.isConnected ? previousFocus : launcher;
          target.focus({ preventScroll: true });
        }, { signal });
        time.addEventListener('change', syncTime, { signal });
        country.addEventListener('change', syncPhone, { signal });
        phone.addEventListener('input', syncPhone, { signal });
        phone.addEventListener('change', syncPhone, { signal });
        form.addEventListener('submit', event => {
          syncPhone();
          if (!phone.reportValidity()) {
            event.preventDefault();
            return;
          }
          write(pendingKey, String(Date.now()));
        }, { signal });
        window.addEventListener('pageshow', () => { syncTime(); syncPhone(); }, { signal });
        document.addEventListener('pointerdown', () => { interacted = true; }, { signal, once: true });
        document.addEventListener('keydown', () => { interacted = true; }, { signal, once: true });
        syncTime();
        syncPhone();
        launcher.hidden = false;
        const pendingAt = Number(read(pendingKey));
        const ownResponse = location.hash === '#DmIaContact' || (pendingAt > 0 && Date.now() - pendingAt < 600000);
        if (ownResponse && status !== 'idle') {
          if (status === 'success') {
            fields.hidden = true;
            success.hidden = false;
            clearPending();
          } else {
            error.hidden = false;
            clearPending();
          }
          open();
        } else if (status === 'idle' && this.dataset.editor !== 'true' && (this.dataset.frequency === 'page' || !read(seenKey))) {
          this.timer = setTimeout(() => {
            const otherModal = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden');
            if (!interacted && !otherModal) open();
          }, Number(this.dataset.delay) * 1000);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.controller = null;
        if (this.dialog?.open) document.documentElement.classList.remove('dmia-scroll-lock');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
